/**
 *
 * @param {{key:string,value:int}[]} breakpoints
 * @param {{key:string, minWidth:int|undefined, maxWidth:int|undefined}[]} cluster
 * @return {{key:string,value:int}[]}
 */
export const clusterize = (breakpoints, cluster) =>{
	const result = {};
	for( let bp of breakpoints ){
		const width = parseInt(bp.key);
		const c = getCluster(width, cluster);
		if(c !== false){
			if(typeof result[c.key] === typeof undefined){
				result[c.key] = {
					...c,
					value: 0,
				};
			}
			result[c.key].value += bp.value;
		} else {
			result[bp.key] = bp;
		}
	}
	return Object.values(result).sort((a,b)=>{
		return b.value - a.value;
	});
};

/**
 *
 * @param {int} width
 * @param {{key:string,minWidth:int|undefined,maxWidth:int|undefined}[]} cluster
 * @return {boolean|{key:string,minWidth:int|undefined,maxWidth:int|undefined}}
 */
export const getCluster = (width, cluster)=>{
	for(let c of cluster){
		const minWidth = (typeof c.minWidth === typeof 0 && c.minWidth > 0)? c.minWidth: false;
		const maxWidth = (typeof c.maxWidth === typeof 0 && c.maxWidth > 0)? c.maxWidth: false;
		if(
			(minWidth === false || minWidth <= width)
			&&
			(maxWidth === false || maxWidth >= width)
		){
			return c;
		}
	}
	return false;
};